import ObjectToQueryString from "utils/ObjectToQueryString";
import * as actions from "./actionTypes";
import * as config from "config";


export function createApprovalWorkflow(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiCreateApprovalWorkflow,
            method: "post",
            data: params,
            onStart: actions.CREATE_APPROVAL_WORKFLOW_START,
            onSuccess: actions.CREATE_APPROVAL_WORKFLOW,
            onError: actions.CREATE_APPROVAL_WORKFLOW_FAILED,
        },
    }
}

export function resetApprovalWorkflow(payload){
    return {
        type: actions.CREATE_APPROVAL_WORKFLOW_RESET,
        payload
    }
}

export function resetUpdatedWorkflow(){
    return {
        type: actions.UPDATE_APPROVAL_WORKFLOW_RESET,
        payload: {}
    }
}

export function getApprovalWorkflows(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetApprovalWorkflows + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_APPROVAL_WORKFLOWS_START,
            onSuccess: actions.GET_APPROVAL_WORKFLOWS,
            onError: actions.GET_APPROVAL_WORKFLOWS_FAILED,
        },
    }
}

export function getRoles(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiGetRoles}?employerId=${params.employerId}`,
            method: "get",
            data: {},
            onStart: actions.GET_ROLES_START,
            onSuccess: actions.GET_ROLES,
            onError: actions.GET_ROLES_FAILED,
        },
    }
}

export function updateApprovalWorkflow(params, workflowId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiUpdateApprovalWorkflow}/${workflowId}`,
            method: "patch",
            data: params,
            onStart: actions.UPDATE_APPROVAL_WORKFLOW_START,
            onSuccess: actions.UPDATE_APPROVAL_WORKFLOW,
            onError: actions.UPDATE_APPROVAL_WORKFLOW_FAILED,
        },
    }
}

export function deleteApprovalWorkflow(workflowId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiUpdateApprovalWorkflow}/${workflowId}`,
            method: "delete",
            data: {},
            onStart: actions.DELETE_APPROVAL_WORKFLOW_START,
            onSuccess: actions.DELETE_APPROVAL_WORKFLOW,
            onError: actions.DELETE_APPROVAL_WORKFLOW_FAILED,
        },
    }
}

export function resetDeletedWorkflow(){
    return {
        type: actions.DELETE_APPROVAL_WORKFLOW_RESET,
        payload: {},
    }
}

export function enableWorkflow(params, workflowId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiSetApprovalWorkflowStatus}/${workflowId}`,
            method: "patch",
            data: params,
            onStart: actions.ENABLE_APPROVAL_WORKFLOW_START,
            onSuccess: actions.ENABLE_APPROVAL_WORKFLOW,
            onError: actions.ENABLE_APPROVAL_WORKFLOW_FAILED,
        },
    }
}

export function disableWorkflow(params, workflowId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiSetApprovalWorkflowStatus}/${workflowId}`,
            method: "patch",
            data: params,
            onStart: actions.DISABLE_APPROVAL_WORKFLOW_START,
            onSuccess: actions.DISABLE_APPROVAL_WORKFLOW,
            onError: actions.DISABLE_APPROVAL_WORKFLOW_FAILED,
        },
    }
}

export function resetEnabledWorkflow(){
    return {
        type: actions.ENABLE_APPROVAL_WORKFLOW_RESET,
        payload: {}
    }
}

export function resetDisabledWorkflow(){
    return {
        type: actions.DISABLE_APPROVAL_WORKFLOW_RESET,
        payload: {}
    }
}

export function updateApprovalWorkflowStage(params, workflowId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiUpdateApprovalWorkflow}/${workflowId}`,
            method: "patch",
            data: params,
            onStart: actions.UPDATE_APPROVAL_WORKFLOW_START,
            onSuccess: actions.UPDATE_APPROVAL_WORKFLOW,
            onError: actions.UPDATE_APPROVAL_WORKFLOW_FAILED,
        },
    }
}

export function createRequest(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiCreateRequest,
            method: "post",
            data: params,
            onStart: actions.CREATE_REQUEST_START,
            onSuccess: actions.CREATE_REQUEST_START,
            onError: actions.CREATE_REQUEST_FAILED,
        },
    }
}

export function resetCreateRequest(){
    return {
        type: actions.CREATE_REQUEST_RESET,
    }
}

export function getRequestAnalytics(){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetRequestAnalytics,
            method: "get",
            data: {},
            onStart: actions.GET_REQUEST_ANALYTICS_START,
            onSuccess: actions.GET_REQUEST_ANALYTICS,
            onError: actions.GET_REQUEST_ANALYTICS_FAILED,
        },
    }
}

export function getRequests(params){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetRequests + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_REQUESTS_START,
            onSuccess: actions.GET_REQUESTS,
            onError: actions.GET_REQUESTS_FAILED,
        },
    }
}

export function getRequestApprovals(){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetRequestApprovals,
            method: "get",
            data: {},
            onStart: actions.GET_REQUEST_APPROVALS_START,
            onSuccess: actions.GET_REQUEST_APPROVALS,
            onError: actions.GET_REQUEST_APPROVALS_FAILED,
        },
    }
}

export function postRequestComment(params, requestId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiPostRequestComment + "/" + requestId,
            method: "post",
            data: params,
            onStart: actions.POST_REQUEST_COMMENT_START,
            onSuccess: actions.POST_REQUEST_COMMENT,
            onError: actions.POST_REQUEST_COMMENT_FAILED,
        },
    }
}

export function resetPostRequestComment(){
    return {
        type: actions.POST_REQUEST_COMMENT_RESET,
        payload: {}
    }
}

export function approveRequest(requestId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiApproveRequest}/${requestId}`,
            method: "patch",
            data: {},
            onStart: actions.APPROVE_REQUEST_START,
            onSuccess: actions.APPROVE_REQUEST,
            onError: actions.APPROVE_REQUEST_FAILED,
        },
    }
}

export function rejectRequest(params, requestId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiRejectRequest}/${requestId}`,
            method: "patch",
            data: params,
            onStart: actions.REJECT_REQUEST_START,
            onSuccess: actions.REJECT_REQUEST,
            onError: actions.REJECT_REQUEST_FAILED,
        },
    }
}

export function cancelRequest(requestId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: `${config.apiCancelRequest}/${requestId}`,
            method: "patch",
            data: {},
            onStart: actions.CANCEL_REQUEST_START,
            onSuccess: actions.CANCEL_REQUEST,
            onError: actions.CANCEL_REQUEST_FAILED,
        },
    }
}

export function resetCancelRequest(){
    return {
        type: actions.CANCEL_REQUEST_RESET,
        payload: {}
    }
}

export function resetApproveRequest(){
    return {
        type: actions.APPROVE_REQUEST_RESET,
        payload: {}
    }
}

export function resetRejectRequest(){
    return {
        type: actions.REJECT_REQUEST_RESET,
        payload: {}
    }
}

export function getRequestComments(requestId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiGetRequestComments + "/" + requestId,
            method: "get",
            data: {},
            onStart: actions.GET_REQUEST_COMMENTS_START,
            onSuccess: actions.GET_REQUEST_COMMENTS,
            onError: actions.GET_REQUEST_COMMENTS_FAILED,
        },
    }
}

export function updateRequestDisbursement(requestId){
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiGrossPayrollBaseUrl,
            url: config.apiUpdateRequestDisbursement + "/" + requestId,
            method: "patch",
            data: {},
            onStart: actions.UPDATE_REQUEST_DISBURSEMENT_START,
            onSuccess: actions.UPDATE_REQUEST_DISBURSEMENT,
            onError: actions.UPDATE_REQUEST_DISBURSEMENT_FAILED,
        },
    }
}